module.exports = __webpack_public_path__ + "img/ready_audit.4fcf118.svg";